// extracted by mini-css-extract-plugin
module.exports = {"heading":"_404-module--heading--1S2uI","copy":"_404-module--copy--uDhVl","link":"_404-module--link--1t11s"};